import React from 'react';
import PropTypes from 'prop-types';
import { JourneyContext } from './context';
import { useResolvedJourney } from './useResolvedJourney';

/**
 * Resolves the active journey and provides it on `JourneyContext`. Until the loader resolves,
 * consumers see `EMPTY_JOURNEY`. See .claude/context/journey-resolution.md.
 */
export const JourneyProvider = ({ journeyId = 'assistant', children }) => {
  // Render side: ignores `isResolving` (AssistantDataProvider holds instead).
  // See .claude/context/journey-resolution.md.
  const { journey } = useResolvedJourney(journeyId);

  return (
    <JourneyContext.Provider value={journey}>
      {children}
    </JourneyContext.Provider>
  );
};

JourneyProvider.propTypes = {
  journeyId: PropTypes.string,
  children: PropTypes.node.isRequired,
};
